import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import numDesc from 'helpers/numDesc';
import { I18nHoc, Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';

import imgRisk from '../assets/thumb_1553.jpeg';

import translates from '../about-i18n.json';

const classes = new Bem('blockAbout');

@I18nHoc(translates)
export default class AboutBlock extends Component {
  static propTypes = {
    className: PropTypes.string,
    topic: PropTypes.string,
    countCondition: PropTypes.number
  };

  render() {
    const { className, topic, countCondition } = this.props;

    return (
      <div {...classes({ extra: className })}>
        <Trans lang="ru">
          <Row {...classes('row', 'block')} allColumn>
            <Col {...classes('col', 'topic')} allPr={0}>
              <Row {...classes('row', 'topic')} mpColumn>
                <Col {...classes('col', 'h1')} allPr={0}>
                  <div {...classes('text', 'h1')}><h1 children={topic || 'Первый проект по оценке надёжности новостроек Украины'} /></div>
                </Col>
                <Col {...classes('col', 'description')} mdAuto mtAuto allPr={0}>
                  <div {...classes('description', 'separatorBottom')}>
                    <p {...classes('text')} children="Сервис, который делает доступным проверку своего ЖК для каждого инвестора. Это экспертная, регулярно обновляемая оценка." />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col {...classes('col', 'img')} allPr={0}>
              <div {...classes('imgContainer')}>
                <img {...classes('img')} src={imgRisk} alt="Современное здание" loading="lazy" decoding="async" />
              </div>
            </Col>
            <Col {...classes('col', 'info')} allPr={0}>
              <ul {...classes('list')}>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text', 'list')} children="Миссия проекта — дать покупателям простой инструмент оценки рисков инвестиций в новостройки." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text', 'list')} children="Авторы проекта занимаются аналитикой рынка недвижимости с 1996 года и выступают за его прозрачность для всех участников." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text', 'list')} children={`Проект построен на методологии оценки надёжности новостройки по ${numDesc(countCondition, 'параметру', 'параметрам', 'параметрам')}, на которую в 2019 году зарегистрировано авторское право.`} />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text', 'list')} children="Проект не зависит от влияния государственных структур и компаний-застройщиков." />
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
        </Trans>
        <Trans lang="ua">
          <Row {...classes('row', 'block')} allColumn>
            <Col {...classes('col', 'topic')} allPr={0}>
              <Row {...classes('row', 'topic')} mpColumn>
                <Col {...classes('col', 'h1')} allPr={0}>
                  <div {...classes('text', 'h1')}><h1 children={topic || 'Перший проєкт по оцінці надійності новобудов України'} /></div>
                </Col>
                <Col {...classes('col', 'description')} mdAuto mtAuto allPr={0}>
                  <div {...classes('description', 'separatorBottom')}>
                    <p {...classes('text')} children="Сервіс, який робить доступним перевірку свого ЖК для кожного інвестора. Це експертна, регулярно оновлювана оцінка." />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col {...classes('col', 'img')} allPr={0}>
              <div {...classes('imgContainer')}>
                <img {...classes('img')} src={imgRisk} alt="Сучасна будівля" loading="lazy" decoding="async" />
              </div>
            </Col>
            <Col {...classes('col', 'info')} allPr={0}>
              <ul {...classes('list')}>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text', 'list')} children="Місія проєкту — дати покупцям простий інструмент оцінки ризиків інвестицій в новобудови." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text', 'list')} children="Автори проєкту займаються аналітикою ринку нерухомості з 1996 року і виступають за його прозорість для всіх учасників." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text', 'list')} children={`Проєкт побудований на методології оцінки надійності новобудови по ${numDesc(countCondition, 'параметру', 'параметрам', 'параметрам')}, на яку в 2019 році зареєстровано авторське право.`} />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text', 'list')} children="Проєкт не залежить від впливу державних структур і компаній-забудовників." />
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
        </Trans>
      </div>
    );
  }
}
